module.exports = __webpack_public_path__ + "img/introducer-en-us.b4dc9d94.jpg";